import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileOtherUserReceiveMessageState {
  functionContents: { hidden: boolean; content: string; isFinished: boolean };
  groupMemberId: number;
  groupMemberName: string;
  groupName: string;
  groupTypeId: number;
  groupTypeName: string;
  datetime: number;
  groupId: number;
  otherUserOpinionMessagesCaseId: number;
  exist: boolean;
}

/**
 * ### MobileOtherUserReceiveMessage store
 *
 * - store
 *   - 受信メッセージ(施設関係者)のメッセージ情報を保持する
 * - action, mutation
 *   - 受信メッセージ(施設関係者)のメッセージ情報を格納する
 */
@Module({ name: "mobileOtherUserReceiveMessage" })
export default class MobileOtherUserReceiveMessage extends VuexModule implements MobileOtherUserReceiveMessageState {
  functionContents = {
    hidden: false,
    content: "",
    isFinished: false
  };
  groupMemberId = -1;
  groupMemberName = "";
  groupName = "";
  groupTypeId = -1;
  groupTypeName = "";
  datetime = -1;
  groupId = -1;
  otherUserOpinionMessagesCaseId = -1;
  exist = false;

  /** stateのgetters */
  get mobileOtherUserReceiveMessageState(): MobileOtherUserReceiveMessageState {
    const state: MobileOtherUserReceiveMessageState = {
      functionContents: this.functionContents,
      groupMemberId: this.groupMemberId,
      groupMemberName: this.groupMemberName,
      groupName: this.groupName,
      groupTypeId: this.groupTypeId,
      groupTypeName: this.groupTypeName,
      datetime: this.datetime,
      groupId: this.groupId,
      otherUserOpinionMessagesCaseId: this.otherUserOpinionMessagesCaseId,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILEOTHERUSERRECEIVEMESSAGESTATE(state: MobileOtherUserReceiveMessageState) {
    this.functionContents = state.functionContents;
    this.groupMemberId = state.groupMemberId;
    this.groupMemberName = state.groupMemberName;
    this.groupName = state.groupName;
    this.groupTypeId = state.groupTypeId;
    this.groupTypeName = state.groupTypeName;
    this.datetime = state.datetime;
    this.groupId = state.groupId;
    this.otherUserOpinionMessagesCaseId = state.otherUserOpinionMessagesCaseId;
    this.exist = true;

    return;
  }

  @Mutation
  private RESET_MOBILEOTHERUSERRECEIVEMESSAGESTATE() {
    this.functionContents = {
      hidden: false,
      content: "",
      isFinished: false
    };
    this.groupMemberName = "";
    this.groupName = "";
    this.groupTypeId = 0;
    this.groupTypeName = "";
    this.datetime = 0;
    this.groupId = 0;
    this.otherUserOpinionMessagesCaseId = 0;
    this.exist = false;

    return;
  }

  /**
   * ### 受信メッセージ(施設関係者)のメッセージ情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileOtherUserReceiveMessageState(payload: { state: MobileOtherUserReceiveMessageState }): void {
    this.SET_MOBILEOTHERUSERRECEIVEMESSAGESTATE(payload.state);

    return;
  }

  /**
   * ### 受信メッセージ(施設関係者)のメッセージ情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileOtherUserReceiveMessageState(): void {
    this.RESET_MOBILEOTHERUSERRECEIVEMESSAGESTATE();

    return;
  }
}
